import { TranslationStateStatistics } from './translation-state-statistics';

export class ShareCalculator {
  private minimalShare = 5;

  public RecalculateShares(total: number, statistics: TranslationStateStatistics[]): void {
    statistics.forEach((s) => {
      s.percent = Math.round((s.count / total) * 100);
    });
  }
  public RecalculateSmallShares(shares: TranslationStateStatistics[]): void {
    const sharesTooSmall = shares.filter((s) => s.percent < this.minimalShare);
    if (sharesTooSmall.length == 0) {
      return;
    }

    // reduce large shares but not those barely above the limit
    const shareToReAllocate = sharesTooSmall.reduce((sum, stateStat) => sum + (5 - stateStat.percent), 0);

    const resizeableShares = shares.filter((s) => s.percent > this.minimalShare * 1.5);
    if (resizeableShares.length == 0) {
      console.error('Could not increase display size of very small shares.');
      return;
    }

    const resizeableSharesTotal = resizeableShares.reduce((sum, stateStat) => sum + stateStat.percent, 0);
    resizeableShares.forEach((share) => {
      const modification = (share.percent / resizeableSharesTotal) * shareToReAllocate;
      share.percent -= modification;
    });

    // finally increase small shares
    sharesTooSmall.forEach((share) => {
      share.percent = this.minimalShare;
    });
  }
}
